export const main = {
  display: "flex",
  width: "100%",
  height: "100px",
  backgroundColor: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.12)",
  margin: "7px auto",
};

export const left = {
  width: "70%",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
};

export const detailsCont = {
  width: "70%",
  display: "flex",
  justifyContent: "left",
  padding: "5px 15px 15px",
};

export const first = {
  width: "42%",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
};

export const last = {
  width: "50%",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
};

export const right = {
  width: "30%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const mini = {
  width: "100px",
};
